/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_TradePreClearanceDto } from '../models/PagedResultDto_TradePreClearanceDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';
import type { Wealthlane_CustomerService_Dtos_TradePreClearance_CreateOrUpdateTradePreClearanceDto } from '../models/Wealthlane_CustomerService_Dtos_TradePreClearance_CreateOrUpdateTradePreClearanceDto';
import type { Wealthlane_CustomerService_Dtos_TradePreClearance_TradePreClearanceParticipantsDto } from '../models/Wealthlane_CustomerService_Dtos_TradePreClearance_TradePreClearanceParticipantsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TradePreClearanceService {

    /**
     * @param departmentId
     * @param jobTitleId
     * @param employeTypeId
     * @param typeIds
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_TradePreClearanceDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTradePreClearanceTradePreClearanceList(
        departmentId?: string,
        jobTitleId?: string,
        employeTypeId?: string,
        typeIds?: Array<number>,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_TradePreClearanceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/trade-pre-clearance/trade-pre-clearance-list',
            query: {
                'DepartmentId': departmentId,
                'JobTitleId': jobTitleId,
                'EmployeTypeId': employeTypeId,
                'TypeIds': typeIds,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppTradePreClearanceSaveTradePreClearance(
        requestBody?: Wealthlane_CustomerService_Dtos_TradePreClearance_CreateOrUpdateTradePreClearanceDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/trade-pre-clearance/save-trade-pre-clearance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TradePreClearance_TradePreClearanceParticipantsDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTradePreClearanceTradePreClearanceParticipantsList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TradePreClearance_TradePreClearanceParticipantsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/trade-pre-clearance/trade-pre-clearance-participants-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppTradePreClearanceRemovePreclearance(
        requestBody?: Array<string>,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/trade-pre-clearance/remove-preclearance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
